import { cloneDeep, get, isEmpty } from 'lodash';

import { mergeConfigWithBannerAndMessage } from '../../detailLocationPage/DetailLocationPage.helper';
import { MessagingToggle } from './BulkEditMessagingPage.interface';

export const deriveBannerToggle = (config: unknown): boolean => {
  if (!config || (typeof config === 'object' && isEmpty(config))) {
    return true;
  }

  const bannerActive = get(
    config,
    'cod.confirmSetting.header.review.banner.active',
  );

  return typeof bannerActive === 'boolean' ? bannerActive : true;
};

export const deriveMessagingToggle = (config: unknown): boolean => {
  if (!config || (typeof config === 'object' && isEmpty(config))) {
    return true;
  }

  const hideCandidates: Array<boolean | undefined> = [
    get(config, 'cod.codSetting.topMessage.hideRmhcMessage'),
    get(config, 'cod.confirmSetting.topMessage.hideRmhcMessage'),
  ];

  const hideValues = hideCandidates.filter(
    (value): value is boolean => typeof value === 'boolean',
  );

  if (hideValues.length === 0) {
    return true;
  }

  return hideValues.every((hideValue) => !hideValue);
};

export const buildToggleFromConfig = (config: unknown): MessagingToggle => ({
  banner: deriveBannerToggle(config),
  messaging: deriveMessagingToggle(config),
});

export const applyToggleToConfig = (
  config: unknown,
  toggle: MessagingToggle,
): Record<string, unknown> => {
  const clonedConfig = cloneDeep(config) as Record<string, unknown>;
  const existingConfig =
    clonedConfig && typeof clonedConfig === 'object' ? clonedConfig : {};

  return mergeConfigWithBannerAndMessage(
    existingConfig,
    toggle.banner,
    toggle.messaging,
  );
};
